import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { currentQuoteState, currentAccountState, authenticationState } from 'state/atoms';
import {
  getQuoteFromStorage,
  getCurrentAccountFromStorage,
  getAuthFromStorage,
} from 'connectors/storage';

export const LocalStorageSync = () => {
  const setCurrentQuote = useSetRecoilState(currentQuoteState);
  const setCurrentAccount = useSetRecoilState(currentAccountState);
  const setAuthentication = useSetRecoilState(authenticationState);

  // Listen for changes in localstorage and update the relevant state
  useEffect(() => {
    const onStorageChange = () => {
      setCurrentQuote(getQuoteFromStorage());
      setCurrentAccount(getCurrentAccountFromStorage());
    };

    window.addEventListener('storage', onStorageChange);
    return () => {
      window.removeEventListener('storage', onStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Updates authentication state from the local storage on an interval
  useEffect(() => {
    const interval = setInterval(() => {
      setAuthentication(getAuthFromStorage());
    }, 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
